import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const ShowDocument = () => {
  const navigate = useNavigate();
  const [news, setNews] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/documents/list`
        );
        const documentid = window.location.href.split('/').pop();
        if (documentid) {
          setNews(
            response.data.data.filter(
              (item) => String(item.id) === documentid
            )[0]
          );
        } else {
          navigate('/documents/list');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const prettyDate = (zuluDate) => {
    const date = new Date(zuluDate);

    const formattedDate = `${date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })} ${date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })}`;

    return formattedDate;
  };

  return (
    <>
      <PageHeader
        title='Document Details'
        description=''
        className='mb-3'
      ></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : news?.id ? (
        <Table hover responsive>
          <tbody>
            <tr>
              <td>Title: {news.title}</td>
            </tr>
            <tr>
              <td>Audience: {news.audience}</td>
            </tr>
            <tr>
              <td>Category: {news.category}</td>
            </tr>
            <tr>
              <td>
                File:{' '}
                <a href={news.doc_url} target='_blank' rel='noopener noreferrer'>
                  {news.doc_url}
                </a>
              </td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <div>Document not found</div>
      )}
    </>
  );
};

export default ShowDocument;
